import styled, { css } from 'styled-components';

import { TransientProps } from '@common/types';

type EmojiButtonProps = TransientProps<{ small: boolean }>;

export const PickerWrapper = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.base.border};
    border-radius: 0.75rem;
    box-shadow: ${theme.shadows.lg};
    overflow: hidden;

    .epr-main {
      border: none;
    }
  `}
`;

export const EmojiButton = styled.button<EmojiButtonProps>`
  ${({ theme, $small }) => css`
    width: ${$small ? '2rem' : '2.375rem'};
    height: ${$small ? '2rem' : '2.375rem'};
    border-radius: ${$small ? '9999px' : '0.75rem'};
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${theme.colors.foreground[40]};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: ${theme.transition.default};

    :hover {
      background: ${theme.colors.brand.primary.opaque};
      color: ${theme.colors.brand.primary.default};
    }
  `}
`;
